const actionTypes = {
  LOGIN: "LOGIN",
  LOGIN_FAILED: "LOGIN_FAILED",
};

export default actionTypes;
